export const pathMap = {
  home: '/',
  culture: '/culture',
  services: '/services',
  blog: '/blog',
  case: '/case/:slug',
  article: '/blog/:slug',
  sitemap: '/sitemap-articles.xml',
} as const

type PathKey = keyof typeof pathMap
type PathValue = (typeof pathMap)[PathKey]

export const getDynamicPath = (path: PathValue, identifier: string) =>
  path.replace(/:id|:slug/g, identifier)
